import React, { useCallback, useEffect, useState } from 'react';
import { Button, HStack, Select, Text } from '@chakra-ui/react';
import { client } from '@php-beam/packages/frontend/src/api/client';
import { route } from '@php-beam/packages/frontend/src/hooks/useRouter';

interface SubmissionInfo {
  id: number;
  quote_id: number;
  status: string;
  business_name: string;
}

export default function SubmissionSelector({
  leadId,
  activeSubmissionId,
  onSelect,
}: {
  leadId: number;
  activeSubmissionId: number | null;
  onSelect: (id: number | null) => void;
}) {
  const [submissions, setSubmissions] = useState<SubmissionInfo[]>([]);

  const refresh = useCallback(() => {
    client
      .get(
        route('customers.underwriting.index') +
          `?lead_id=${leadId}&status=approved,rejected,pending,need_more_info&page=1`,
      )
      .then((res) => {
        const data = res.data.submissions?.data ?? [];
        setSubmissions(data);
      });
  }, [leadId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    if (activeSubmissionId) {
      refresh();
    }
  }, [activeSubmissionId]);

  return (
    <HStack mb={3} spacing={2}>
      <Text fontSize="xs" fontWeight="semibold" color="gray.500">
        Existing submission:
      </Text>
      <Select
        size="xs"
        maxW="300px"
        placeholder={
          submissions.length === 0 ? 'No submissions' : 'Select a submission'
        }
        value={activeSubmissionId ?? ''}
        onChange={(e) =>
          onSelect(e.target.value ? Number(e.target.value) : null)
        }
        isDisabled={submissions.length === 0}
      >
        {submissions.map((s) => (
          <option key={s.id} value={s.id}>
            #{s.id} — Quote #{s.quote_id} ({s.status})
          </option>
        ))}
      </Select>
      <Button size="xs" variant="ghost" onClick={refresh}>
        Refresh
      </Button>
    </HStack>
  );
}
